import { render, staticRenderFns } from "./AssetCategoryView.vue?vue&type=template&id=7b8e379a&"
import script from "./AssetCategoryView.vue?vue&type=script&lang=js&"
export * from "./AssetCategoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports